import axiosInstance from '../api.service';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Project/";

const getProjectById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getProjects = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjects', constants.REQUIRE_INTERCEPTORS);

const getFormTypes = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetFormTypes', constants.REQUIRE_INTERCEPTORS);

const saveProject = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProject', model, constants.REQUIRE_INTERCEPTORS);

const deleteProject = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProject?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getProjectById,
    getProjects,
    getFormTypes,
    saveProject,
    deleteProject
}